// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3Ns1S","savePackageButton":"ClientWallet_savePackageButton__2dfVN"};